import {_Objects} from './main';
import {Form} from './Form';
import {mutationLogin, mutationLogout, mutationRefreshToken, queryActualYear} from "./graphql/queries";
import {setAccessToken, clearTokenInfo, checkExpiredToken} from "./helpers";

export async function checkLogin() {
    const actualYearData = await queryActualYear();
    _Objects.actualYear = actualYearData.data.actualYear;
    const expired = checkExpiredToken();
    if (expired) {
        try {
            const token = localStorage.getItem('token');
            const refreshTokenData = await mutationRefreshToken({token});
            setAccessToken(refreshTokenData.data.refreshToken);
        } catch (error) {
            clearTokenInfo();
        }
    }
    const token = localStorage.getItem('token');
    if (token && token.length) {
        $('.js-login').addClass('_logged-in');
        $('html').addClass('logged-in');
        _Objects.isLoggedIn = true;
    }
    return new Promise(function (resolve, reject) {
       resolve();
    });
}

export class Login {
    constructor(selector) {
        let _this = this;

        _this.$container = $(selector);
        _this._loginForm = null;

        _this._container = this;
        _this.$container.data('_login', _this._container);

        _this.init();
    }

    init() {
        let _this = this;

        _this.initLoginForm();
        _this.initEvents();
    }
    initLoginForm() {
        let _this = this;

        let _loginForm = _this._loginForm = $.map($('.js-login-form'), (form) => {
            return new LoginForm(form);
        });

        _this.$loginForm = $($.map(_loginForm, (form) => form.$container[0]));
        _this.$loginFormDD = $($.map(_loginForm, (form) => form.$dropdown[0]));
    }
    initEvents() {
        let _this = this;
        let $container = _this.$container;
        let $loginForm = _this.$loginForm;

        $container.on('reset', (e) => {
            _this.onReset(e.currentTarget);
        });
        $loginForm.on('submitted', (e, data) => {
            if (data.logged) _this.onLoggedIn(data.token);
            else _this.onLoggedOut();
        });
    }

    reset() {
        let _this = this;
        _this.$container.trigger('reset');
    }
    onReset(login) {
        let _this = this;
        let $container = $(login);

        let $currFormDD = $container.find(_this.$loginFormDD);
        if (!$currFormDD.is('.sl_active')) return false;
        let $currddSl = $container.find('.dd-sl');
        $currddSl.trigger('ddbox.toggle');

        let _currForm = _this._loginForm.filter((form) => {
            let $currForm = $container.find(form.$container);
            return !!$currForm.length;
        });

        _currForm.forEach((form) => form.reset());
    }

    onLoggedIn(data) {
        let _this = this;

        setAccessToken(data);
        _this.reset();

        _this.$container.addClass('_logged-in');
        $('html').addClass('logged-in');
        _Objects.isLoggedIn = true;
    }
    onLoggedOut() {
        let _this = this;

        _this.$container.removeClass('_logged-in');
        $('html').removeClass('logged-in');
        _Objects.isLoggedIn = false;
    }
}

export class LoginForm {
    constructor(selector) {
        let _this = this;

        _this.$container = $(selector);
        _this.$dropdown = _this.$container.find('.js-login-form-dd');
        _this._form = null;
        // _this.$input = _this.$container.find('.js-login-form-input');
        _this.$btnSubmit = _this.$container.find('.js-login-form-submit');
        _this.$btnLogout = _this.$container.find('.js-login-form-logout');

        _this._container = this;
        _this.$container.data('_loginForm', _this._container);

        _this.init();
    }

    init() {
        let _this = this;

        _this.initForm();
        _this.initEvents();
    }
    initForm() {
        let _this = this;
        _this._form = new Form(_this.$container[0]);
    }
    initEvents() {
        let _this = this;
        let $container = _this.$container;
        let $btnSubmit = _this.$btnSubmit;
        let $btnLogout = _this.$btnLogout;

        $container.on('submitted', (e) => {
            e.stopPropagation();
            _this.onSubmitSuccess();
        });
        $container.on('failed', (e) => {
            e.stopPropagation();
            _this.onSubmitSuccess();
        });
        $btnSubmit.on('click', async (e) => {
            _this.requestLogin();
        });
        $btnLogout.on('click', async (e) => {
            _this.requestLogout();
        });
    }

    requestLogin() {
        let _this = this;
        let _form = _this._form;

        _form.submitForm(({login, password}) => {
            const variables = {
                email: login,
                password
            };
            return mutationLogin(variables);
        });
    }
    requestLogout() {
        let _this = this;
        let _form = _this._form;

        _form.submitForm(async () => {

            try {
              await mutationLogout({token: localStorage.getItem('token')});
            } catch (e) {
              console.error(e);
            }
            clearTokenInfo();
            return true;

        }, true); // true говорит, что мы выходим: `loggingOut => true`
    }

    onSubmitSuccess() {
        let _this = this;
    }
    reset() {
        let _this = this;
        _this._form.reset();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/Login.js